import React from 'react'

export default () => (
	<svg id="add_box-24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
		<path id="Tracé_215" data-name="Tracé 215" d="M0,0H25.3V25.3H0Z" fill="none"/>
		<path id="Tracé_216" data-name="Tracé 216" d="M20.153,3H5.144A2.144,2.144,0,0,0,3,5.144V20.153A2.144,2.144,0,0,0,5.144,22.3H20.153A2.15,2.15,0,0,0,22.3,20.153V5.144A2.15,2.15,0,0,0,20.153,3Zm0,17.153H5.144V5.144H20.153Zm-8.576-2.144H13.72V13.72h4.288V11.576H13.72V7.288H11.576v4.288H7.288V13.72h4.288Z" transform="translate(-3 -3)"/>
	</svg>
)